module.exports = __webpack_public_path__ + "img/photouploadblue.680e5dc4.png";